import { Box, Link } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StepWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  padding: '1rem',
}));

export const TextBox = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '1rem',
  gap: '0.75rem',
}));

export const BoxCheckbox = styled('div')(() => ({
  padding: '1rem 0 1rem 0',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
}));

export const TermsLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'underline',
  cursor: 'pointer',

  '&:hover': {
    opacity: 0.8,
  },
}));

export const CheckboxInput = styled('input')(() => ({
  width: '1rem',
  height: '1rem',
  border: '2px solid #adaba9',
  borderRadius: '0.25rem',
  cursor: 'pointer',
  flexShrink: 0,
}));

export const CheckboxLabel = styled('label')(() => ({
  fontFamily: 'Rookery_New, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  cursor: 'pointer',
  display: 'block',
}));

export const CenterImage = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginTop: '1rem',
});

export const IconWrapper = styled('img')({
  '& svg': {
    width: '2rem',
    height: '2rem',
    display: 'row',
  },
});
